import React from 'react';
import { Biscuit } from '../../../utils';
import { rbac } from './index';
import t from '../../helpers/t';
import { fileManagerActions } from 'inbooma-api';
import {$} from '../../../../vendor';

const FileManagerSidebarFolderList = props => {

    // @todo If required elsewhere, move the following methods into FileManagerSelector
    const hasChildFolders = folder => typeof folder.child_folders !== 'undefined' && folder.child_folders.length >= 1;

    const hasActiveChildFolders = folder => {
        // Recursively search for any active child folders
        let match = false;

        const searchForActiveChildFolder = _folder => {
            _folder.child_folders.forEach(__folder => {
                if (__folder.id === props.activeFolder) {
                    match = true;
                } else if (hasChildFolders(__folder)) {
                    searchForActiveChildFolder(__folder);
                }
            });
        }

        searchForActiveChildFolder(folder);

        return match;
    }

    return (
        // Other available icon-classes:
        // fi-folder fi-folder-lock fi-folder-add fi-archive fi-results
        <ul>
            {(typeof props.folders[0] === 'undefined' || props.folders[0].parent_id === null) &&
            <li
                title={t('root_folder')}
                style={{cursor:'pointer'}}
                className={"top-dir has-children " + (props.activeFolder === null ? 'active' : '')}
                onClick={props.onClickFolder}>
                <p>/</p>
            </li>
            }
        {props.folders.map(folder => (
            <li
                key={folder.id}
                className={
                    (folder.id === props.activeFolder ? 'active' : '') +
                    (hasChildFolders(folder) ? ' has-children' : '') +
                    (hasChildFolders(folder) && hasActiveChildFolders(folder) ? ' has-active-children' : '')
                }>
                <p
                 data-entity-id={folder.id}
                 title={t('open_folder_${a}',{a:folder.name})}
                 onClick={props.onClickFolder}>
                    {folder.name}
                </p>
                
                {/* Recursively render child_folders */}
                {hasChildFolders(folder) &&
                    <FileManagerSidebarFolderList
                     {...props}
                     folders={folder.child_folders}
                    />
                }
            </li>
        ))}
        </ul>
    );
};

export default props => {

    const folders = props.folders;

    const filterUserDocsByTag = tag => {
        props.dispatch(fileManagerActions.getDocuments({
            token: Biscuit.get('token'),
            tag: tag.slug
        }));

        props.setTagFilter(tag.label);
        props.setAddFolderEditMode(false);
        props.setActiveFolder(null);
        props.setSelectedEntity(null);
    }

    const onToggleLeftBar = (ev) => {

        $('#inb-c-sidebar').toggleClass('open');
        $('html,body').scrollTop(0);
    };

    return (
        <aside
            id="inb-c-sidebar"
            className="filemanager-sidebar"
            style={{float:'left'}}>
            <header className="inb-c-left-bar__title">
                <h1 className="inb-page-title">
                    {t('user_docs',null,'capital')} 
                </h1>
            </header>
            
            {folders.length === 0 && !props.foldersFetchSuccess && 
            <div>
                <div className="inb-c-loader">
                    <div className="inb-c-loader--item inb-c-loader--sidebar-top">
                        <div className="inb-c-loader--bg row">
                        </div>
                    </div>
                </div>
                
                <div className="inb-c-loader">
                    <div className="inb-c-loader--item inb-c-loader--sidebar-center">
                        <div className="inb-c-loader--bg row">
                            <div className="loader-mask r-1 medium-offset-8 medium-4 column"></div>
                            <div className="loader-mask vert-ph-1"></div>
                            <div className="loader-mask vert-ph-2"></div> 
                            <div className="loader-mask r-2 medium-offset-9 medium-3 column"></div>
                            <div className="loader-mask vert-ph-3"></div> 
                            <div className="loader-mask vert-ph-4"></div> 
                        </div>
                    </div>
                </div>
            
                <div className="inb-c-loader">
                    <div className="inb-c-loader--item inb-c-loader--sidebar-center">
                        <div className="inb-c-loader--bg row">
                            <div className="loader-mask r-1 medium-offset-8 medium-4 column"></div>
                            <div className="loader-mask vert-ph-1"></div>
                            <div className="loader-mask vert-ph-2"></div> 
                            <div className="loader-mask r-2 medium-offset-9 medium-3 column"></div>
                            <div className="loader-mask vert-ph-3"></div> 
                            <div className="loader-mask vert-ph-4"></div> 
                        </div>
                    </div>
                </div>
            </div>
            }

            {folders.length !== 0 &&
            <div className="filemanager-sidebar__list">
                    <FileManagerSidebarFolderList
                        folders={folders}
                        activeFolder={props.activeFolder}
                        onClickFolder={props.onClickFolder}
                    />
            </div>
            }

            {rbac.hasPermission('editTags') &&
            <ul id="filemanager-tag-cloud">
            {/* Show the 10 most "popular" tags, sorted by their elements-count */}
            {props.tags
                .filter(tag => tag.counter >= 1)
                .sort((a,b) => {
                    if (a.counter > b.counter) return -1;
                    if (a.counter < b.counter) return 1;
                    return 0;
                })
                .filter((tag, index) => index <= 10)
                .map(tag => (
                <li
                    key={tag.id}
                    title={t('filter_tag_${a}',{a:tag.label})}
                    onClick={() => filterUserDocsByTag(tag) }
                    data-counter={(tag.counter > 6 ? 6 : tag.counter)}>
                    <a href="#">
                        {tag.label}
                    </a>
                </li>
            ))}
            </ul>
            }

            {rbac.hasPermission('write') &&
                <footer
                 className="inb-c-left-bar__footer small-only-float-container center-on-content"
                 style={{transform:'translateY(160px)'}}
                 data-inb-action-link="write">
                    <a href="#"
                        id="toggle-left-bar"
                        className="button secondary show-for-small-only" onClick={(e) => onToggleLeftBar(e)}>
                            <i className="fi fi-filter"></i>
                            <span className="show-for-sr">t('open_filter_menu')</span>
                    </a>
                    { false &&
                    <a
                        id="inb-c-left-bar-add-user"
                        className={"button beautify beautify-" + Biscuit.get('user.client_id')}>
                        <i className="fi fi-folder-add"></i>
                        <span>
                            Ordner/Datei hinzufügen
                        </span>
                    </a>
                    }
                </footer>
            }
        </aside>
    );
};